import styled from 'styled-components';

export const Container = styled.div`
  .header-item {
    & > div:nth-child(1) {
      width: 105px;
    }
    & > div:nth-child(2) {
      width: 142px;
    }
    & > div:nth-child(3),
    & > div:nth-child(4)  {
      width: 115px;
    }
    & > div:nth-child(5)  {
      width: 166px;
    }

    .SingleDatePicker .SingleDatePickerInput {
      min-width: 140px;

      button.SingleDatePickerInput_calendarIcon {
        right: 12px;
        position: relative;
      }
    }

    p {
      margin-bottom: 6px;
    }

    .tooltip {
      border: 0;
      display: flex;
    }

    soma-icon {
      top: 2px;
      margin-left: 8px;
      position: relative;
    }

    .react-select__indicators {
      padding: 0;
      width: 31px;
    }

    .DateRangePicker {
      margin: 0;
    }

    .DateRangePicker .DateRangePickerInput .DateInput_input,
    .SingleDatePicker .SingleDatePickerInput .DateInput_input {
      color: #d3d3d4;
    }

    .DateInput {
      width: 76px!important;
    }

    .CalendarDay {
      &__selected_span,
      &__hovered_span,
      &__hovered_span:hover {
        background: #fff;
        border-color: #e4e7e7;
      }
    }
  }
`;
